import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, Inject, OnChanges, SimpleChanges, AfterViewInit, ChangeDetectorRef, ViewChild } from '@angular/core';

import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonData } from '@infrastructure/CommonData/CommonDataResolver';
import {  TableEditBase } from '@infrastructure/TableEdit/TableEditBase';
import { ControlContainer, NgForm } from '@angular/forms';
import { ModalService } from '@infrastructure/Modal/ModalService';
import { BeneficiaryListPreStageComponent } from './beneficiary-list-pre-stage.component';

import { CommonDataService } from '@infrastructure/CommonData/CommonDataService';
import { Subscription } from 'rxjs';
import { PreFilledProperty } from '@infrastructure/Models/pre-filled-property.interface';
import { isEmpytObject, isNotNullOrUndefinedOrEmpty, isNullOrUndefined } from '@infrastructure/objectUtils';
import { AlertService } from '@infrastructure/Alerts/alert.service';
import DateHelpers from '@infrastructure/DateHelpers';
import { LoadingMaskService } from '@infrastructure/LoadingMask/LoadingMaskService';
import { ModelsService } from '@infrastructure/Models/modelsService';
import { NifValidationService } from '@infrastructure/NifValidation/nif-validation.service';
import { BeneficiaryIdsService } from '@infrastructure/Beneficiaries/beneficiary-ids.service';
import { LegalRepresentationState } from '@infrastructure/Beneficiaries/legal-representation-state.service';
import { BeneficiaryHelperService } from '@infrastructure/Beneficiaries/BeneficiaryHelperService';

@Component({
  selector: 'beneficiary-list-table-edit-pre-stage',
  templateUrl: './beneficiary-list-table-edit-pre-stage.component.html',
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  standalone: false
})
export class BeneficiaryListTableEditPreStageComponent extends TableEditBase<models.BeneficiaryListVM> implements OnInit, OnDestroy, OnChanges {

  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.yesNo)
  public yesNo: models.DimensionVM[];
  @CommonData(DomainCodes.country)
  public countries: models.DimensionVM[];
  @CommonData(DomainCodes.nationality)
  public nationalities: models.DimensionVM[];
  @CommonData(DomainCodes.genders)
  public genders: models.DimensionVM[];

  public maritalStatus: models.Options[];
  @CommonData(DomainCodes.identificationType)
  public documentTypes: models.DimensionVM[];
  @CommonData(DomainCodes.fiscalCategories)
  public fiscalCategories: models.DimensionVM[];
  @CommonData(DomainCodes.incomeHolding)
  public incomeHoldings: models.DimensionVM[];
  @CommonData(DomainCodes.bankAccountTypes)
  public bankAccountTypes: models.DimensionVM[];
  @CommonData(DomainCodes.studyLevel)
  public educationLevel: models.DimensionVM[];

  @Input() dropdowns: models.WorkflowDropdownsVM;
  @Input() qualificationIsBeneficiary: boolean = null;
  @Input() qualificationIsLegalRepresentative: boolean = null;
  @Output() isClosing = new EventEmitter<boolean>();
  @Input() hasLegalRepresentation: string;
  @Input() isFuneraryOrService: boolean = false;
  @Input() workflowInstanceId: number;
  @Input() deceasedSubscriberNumber: number;
  @Input() workflowCode: string;
 // @Input() senderName: string;
  @Input() senderNIF: number;
  @Input() nifDeceased: string;
  @Input() estadoPendente: boolean;
  @Input() deathDate: Date;

  public personType: models.PersonTypeVM;
  public benefitType: models.BenefitTypeVM;
  public beneficiaryIdentification: models.BeneficiaryIdentificationVM;
  public beneficiaryContacts: models.BeneficiaryContactsVM;
  public deceasedRelationship: models.DeceasedRelationshipVM;
  public legalRepresentationIdentification: models.LegalRepresentationIdentificationVM;
  public taxInformation: models.TaxInformationVM;
  public payment: models.PaymentVM;
  public beneficiaryObservations: models.BeneficiaryObservationsVM;
  public notifications: models.NotificationsVM;


  public dataFalecimento: Date;
  public expandedRowIndex: number = null;


  public isVisibleSurvivalPensionBenefit = false;
  public isVisibleReimbursementFuneralBenefit = false;
  public isVisibleFuneralAllowanceBenefit = false;

  public mainSubscription: Subscription = new Subscription();
  public isCommonDataLoaded: boolean = false;

  public dropListRepresentationType: models.Options[] = [];
  public preFilledProperties: PreFilledProperty[] = [];
  private isFirstChange: boolean = false;
  public minDate: Date;
  public maxDate: Date;

  public isDeferida: boolean = false;
  public isRepresentado: boolean = false;
  public isAIndeferir: boolean = false;
  constructor(@Inject(BeneficiaryListPreStageComponent) private parent: Component,
    private modalService: ModalService,
    private commonDataService: CommonDataService,
    private http: HttpClient,
    private BeneficiaryHelperService: BeneficiaryHelperService,
    private alertService: AlertService,
    private loadingMaskService: LoadingMaskService,
    private modelsService: ModelsService,
    private nifValidationService: NifValidationService,
    private beneficiaryIDsService: BeneficiaryIdsService) {
    super(parent, modalService);

    const domains = [
      DomainCodes.yesNo,
      DomainCodes.genders,
      DomainCodes.martialStatus,
      DomainCodes.identificationType
    ];
    this.mainSubscription.add(
      this.commonDataService.getDomains(domains).subscribe(
        (results: models.DomainVM[]) => {
          this.yesNo = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.yesNo).dimensions;
          this.genders = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.genders).dimensions;

          this.documentTypes = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.identificationType).dimensions;
          this.isCommonDataLoaded = true;
        }
      )
    );
    this.minDate = DateHelpers.getMinimumDate();
    this.maxDate = DateHelpers.getMaximumDate();
  }



  ngOnInit(): void {
    super.ngOnInit();

    if (!!this.item) {
      if (isEmpytObject(this.item)) {
        this.item = this.modelsService.getEmptyBeneficiary();
        this.beneficiaryIDsService.itemVerifyHasId(this.item, this.itemList, this.hasLegalRepresentation == 'true');
      }
      
      if (!this.isFirstChange) {
        this.isFirstChange = true;
        this.isDeferida = this.hasLegalRepresentation &&
          (this.item.stateRL === LegalRepresentationState.RepresentacaoDeferida );
        this.isRepresentado = this.hasLegalRepresentation && this.item.beneficiaryID > 1;
        

        this.preFilledProperties.push({ name: "name", preFilledValue: this.item.beneficiaryName, hasValue: isNotNullOrUndefinedOrEmpty(this.item.beneficiaryName) });
        this.preFilledProperties.push({ name: "dateOfBirth", preFilledValue: this.item.dateOfBirth, hasValue: !isNullOrUndefined(this.item.dateOfBirth) });
        this.preFilledProperties.push({ name: "hasNacPT", preFilledValue: this.item.hasNacPT, hasValue: isNotNullOrUndefinedOrEmpty(this.item.hasNacPT) });
        //As per requirement hasNIFPT is always true
        this.item.hasNIFPT = true;
        this.preFilledProperties.push({ name: "hasNIFPT", preFilledValue: this.item.hasNIFPT, hasValue: isNotNullOrUndefinedOrEmpty(this.item.hasNIFPT) });
        this.preFilledProperties.push({ name: "NIF", preFilledValue: this.item.NIF, hasValue: isNotNullOrUndefinedOrEmpty(this.item.NIF) });
        this.preFilledProperties.push({ name: "gender", preFilledValue: this.item.gender, hasValue: isNotNullOrUndefinedOrEmpty(this.item.gender) });
        this.preFilledProperties.push({ name: "civilStateDeathDate", preFilledValue: this.item.civilStateDeathDate, hasValue: isNotNullOrUndefinedOrEmpty(this.item.civilStateDeathDate) });
        this.preFilledProperties.push(
          {
            name: "identificationNumberFirst",
            preFilledValue: this.item.identificationNumberFirst,
            hasValue: isNotNullOrUndefinedOrEmpty(this.item.identificationNumberFirst)
          });
        this.preFilledProperties.push(
          {
            name: "identificationNumberLast",
            preFilledValue: this.item.identificationNumberLast,
            hasValue: isNotNullOrUndefinedOrEmpty(this.item.identificationNumberLast)
          });
        this.preFilledProperties.push(
          {
            name: "identificationDocumentType",
            preFilledValue: this.item.identificationDocumentType,
            hasValue: isNotNullOrUndefinedOrEmpty(this.item.identificationDocumentType)
          });

        this.preFilledProperties.push({
          name: "hasBenefit",
          preFilledValue: this.item.funeralAllowanceBenefit, hasValue: isNotNullOrUndefinedOrEmpty(this.item.funeralAllowanceBenefit) ||
            isNotNullOrUndefinedOrEmpty(this.item.reimbursementFuneralBenefit) || isNotNullOrUndefinedOrEmpty(this.item.survivalPensionBenefit)
        });
        if (this.item.hasNacPT) {
          this.item.identificationDocumentType = "B";
        } else {
          if (this.item.hasNacPT?.toString()=='false') {
            this.item.identificationDocumentType = "P";
          }
        }

        if (this.item?.stateRL == LegalRepresentationState.AIndeferir) {
          this.isAIndeferir = true;
        }
      }

    }



  }


  ngOnDestroy(): void {
    this.mainSubscription.unsubscribe();
    this.isClosing.emit(true);
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (this.dropdowns) {
      this.dropListRepresentationType = this.dropdowns.options
        .filter(el => el.dropdown === "DropdownRepresentationType");
      this.maritalStatus = this.dropdowns.options
        .filter(el => el.dropdown === "dropListMaritalStatus");
    }

  }

  public estadoRegistado(): boolean {
    let result = this.item.stateRL == LegalRepresentationState.AguardaValidacaoDaCGA;
    // Sem representação legal
    result = result && this.isFuneraryOrService?.toString() == 'false';
    result = result && this.isRepresentado;

    return !result;
  }

  public showLegalRepresentationTipology(): boolean {
    let result = this.hasLegalRepresentation?.toString() == 'true';
    result = result && (this.isFuneraryOrService?.toString() == 'false');
    result = result && (this.item.beneficiaryID != 1);
    return result;
  }

  public isBenefitDisabled(): boolean {
    let result = this.hasBenefit();
    result = result && (this.hasLegalRepresentation?.toString() == 'true');
    result = result && (this.senderNIF != this.item.NIF);
    result = result && this.isDisabledByNif();
    return result;
  }


  public hasBenefit(): boolean {
    let result = this.item.survivalPensionBenefit || this.item.funeralAllowanceBenefit || this.item.reimbursementFuneralBenefit;
    return result;
  }

  public isFormValid(): boolean {
    let result = this.item.survivalPensionBenefit || this.item.funeralAllowanceBenefit || this.item.reimbursementFuneralBenefit;

    if (this.tableItemEditForm) {
      const invalidFields: string[] = [];
      Object.keys(this.tableItemEditForm?.controls).forEach(controlKey => {
        this.tableItemEditForm.controls[controlKey].markAsTouched();
        if (this.tableItemEditForm.controls[controlKey].invalid) {
          invalidFields.push(controlKey);
        }
      })
      if (invalidFields.length > 0) {
        console.log(`invalidKeys: ${JSON.stringify(invalidFields)}`)
      }
    }

    return result;
  }


  onEdit(isEdit: boolean) {
    //Validar se há apenas um item com Reembolso por despesas de funeral
    const listToCompare = [...this.itemList];
    if (!isEdit) {
      listToCompare.push(this.item);
    } else {
      const indexOfItem = listToCompare.findIndex(el => el.beneficiaryID == this.item.beneficiaryID);
      listToCompare[indexOfItem] = this.item;
    }
    const moreThanOneRDF = listToCompare.filter(el => el.reimbursementFuneralBenefit?.toString() === 'true').length > 1;
    if (moreThanOneRDF) {

      let modal = <models.BaseModalVM>{
        isError: false,
        message: "WorkflowCreatePM.PreStage.CardRepresentados.WarningMoreThanOneRDF",
        param: {},
        cancelButton: {
          hideButton: true,
          buttonText: "Ok",
          buttonClass: 'btn-primary',
          iconClass: "icon-check"
        }
      };

      this.modalService.showModals([modal]);
      return;
    }

    //Valida se o beneficiaryID ==1 (se é o remetente)
    if (this.item.beneficiaryID > 1) {
      // Verifica se algum dos NIFs é igual ao do remetente
      const duplicateRepLegalNif = this.item.NIF?.toString() === this.senderNIF?.toString();
      if (duplicateRepLegalNif && this.isFuneraryOrService?.toString()=='false') {

        let modal = <models.BaseModalVM>{
          isError: false,
          message: "WorkflowCreatePM.PreStage.CardRepresentados.WarningNIFSender",
          param: {},
          cancelButton: {
            hideButton: true,
            buttonText: "Ok",
            buttonClass: 'btn-primary',
            iconClass: "icon-check"
          }
        };

        this.modalService.showModals([modal]);
        return;
      }   

    }



    //Validar se tem o mesmo NIF que o falecido, se tiver dá erro e não deixa adicionar
    const sameNifDeceased = this.item.NIF?.toString() === this.nifDeceased?.toString();
    if (sameNifDeceased) {

      let modal = <models.BaseModalVM>{
        isError: false,
        message: "WorkflowCreatePM.PreStage.CardRepresentados.WarningNIFDeceased",
        param: {},
        cancelButton: {
          hideButton: true,
          buttonText: "Ok",
          buttonClass: 'btn-primary',
          iconClass: "icon-check"
        }
      };

      this.modalService.showModals([modal]);
      return;
    }   

    // Validar nif
    if (this.item.NIF !== null && this.item.NIF !== undefined) {
      if (this.item.NIF.toString().length !== 9) {
        let modal = <models.BaseModalVM>{
          isError: false,
          message: "WorkflowCreatePM.PreStage.CardRepresentados.InvalidNif",
          param: {},
          cancelButton: {
            hideButton: true,
            buttonText: "Ok",
            buttonClass: 'btn-primary',
            iconClass: "icon-check"
          }
        };

        this.modalService.showModals([modal]);
        return;
      }


      let listToCompare = [...this.itemList];
      if (isEdit) {
        listToCompare.splice(this.editIndex,1);
      }
      const duplicateNif = listToCompare.filter(el => el.NIF === this.item.NIF ).length > 0;
      if (duplicateNif) {

        let modal = <models.BaseModalVM>{
          isError: false,
          message: "WorkflowCreatePM.PreStage.CardRepresentados.WarningNif",
          param: {},
          cancelButton: {
            hideButton: true,
            buttonText: "Ok",
            buttonClass: 'btn-primary',
            iconClass: "icon-check"
          }
        };

        this.modalService.showModals([modal]);
        return;
      }

    }

    //ID do beneficiario
    this.beneficiaryIDsService.itemVerifyHasId(this.item, this.itemList, this.hasLegalRepresentation == 'true');

    //Coloca o estado da representação legal
    if (this.hasLegalRepresentation && (this.item.stateRL == undefined || this.item.stateRL == null)) {
      if (this.senderNIF != this.item.NIF) {
        this.item.stateRL = 1;
      } else {
        this.item.stateRL = 0;
      }
      
    }

    // Remover zeros à esquerda do número de identificação caso o tipo de documento seja BI
    if (this.item.identificationDocumentType == 'B') {

      this.item.identificationNumberFirst = this.item.identificationNumberFirst?.replace(/^0+/, '');
    }

    //Chamada ao BE para validar o habilitando
    const validaHabilitado: models.ValidaHabilitandoPreStagePM_VM = {
      stepCode: "Beneficiaries",
      page: "Beneficiaries",
      workflowCode: this.workflowCode,
      instanceId: this.workflowInstanceId,
      deceasedSubscriberNumber: this.deceasedSubscriberNumber,
      nif: this.item.NIF,
      nic: this.item.identificationNumberFirst,
      idbe: this.item.beneficiaryID,
      xml: this.item,
      tipoDocumentoIdentificacao:this.item.identificationDocumentType

    } as models.ValidaHabilitandoPreStagePM_VM;
    this.loadingMaskService.setShowLoading(true, false, false, true);
    this.http.post<models.WorkflowStatusVM>('api/Workflow/ValidaHabilitandoPM',
      validaHabilitado)
      .subscribe(res => {
      
        if (res.stateCode != 'OK') {
          this.alertService.error(res.message);
          return res;
        } else {
          //Rebemos o audit key da entidade na resposta
          this.item.auditKey = res.workflowInstanceId.toString();
          super.markTouched();

          super.onEdit(isEdit);

        }
      },
        err => {
          this.alertService.error(err);
          this.loadingMaskService.setShowLoading(false, true);
        },
        () => { this.loadingMaskService.setShowLoading(false, true); }
      );

  }

  removeFromList(isEdit) {
    var listToAlter = [...this.itemList];
    if (isEdit) {
      let modal = <models.BaseModalVM>{
        isError: false,
        message: "WorkflowCreatePM.PreStage.CardRepresentados.ConfirmaRemover",
        param: {}
      };

      this.modalService.showModals([modal]).subscribe(result => {
        if (result) {
          const indexToRemove = listToAlter.findIndex(b => b.beneficiaryID == this.item.beneficiaryID)
         
          listToAlter.splice(indexToRemove,1);
          this.listChanged.emit(listToAlter);

          if (!(this.qualificationIsLegalRepresentative?.toString() == 'true')) {
          this.BeneficiaryHelperService.docFaturaOuReciboChange(true, this.item);
          this.BeneficiaryHelperService.docCerNascimentoReqChange(true, this.item);
          this.BeneficiaryHelperService.docAtestadoJuntaFreguesiaChange(true, this.item);
          this.BeneficiaryHelperService.docDeclCompHonraChange(true, this.item);

          this.BeneficiaryHelperService.docProvaEscolarChange(true, this.item, this.deathDate);
          this.BeneficiaryHelperService.docComprovativoSSChange(true, this.item);
          this.BeneficiaryHelperService.docSentencaChange(true, this.item);
          this.BeneficiaryHelperService.docDeclaracaoIRSChange(true, this.item);
          this.BeneficiaryHelperService.docDeclaracaoPensaoAlimentosChange(true, this.item);
          this.BeneficiaryHelperService.docPrestacoesFamiliaresChange(true, this.item);
          this.BeneficiaryHelperService.docPSIChange(true, this.item);
          this.BeneficiaryHelperService.docCertidaoIsensaoIRSChange(true, this.item);
          this.BeneficiaryHelperService.docComprovativoIBANChange(true, this.item);        }
        }
      });
    }

    else
      this.listChanged.emit(listToAlter);

    event.stopPropagation();
  }

  onRemove(isEdit: boolean) {
    super.markTouched()

    super.onRemove(isEdit);

  }

  public isFieldDisabled(name: string): boolean {
    let result = this.preFilledProperties.find(el => el.name == name).hasValue;
    //result = result && (this.item.NIF == this.senderNIF)
    return result;
  }


  public toggleVisibilitySurvivalPensionBenefit() {
    this.isVisibleSurvivalPensionBenefit = !this.isVisibleSurvivalPensionBenefit
  }

  public toggleVisibilityReimbursementFuneralBenefit() {
    this.isVisibleReimbursementFuneralBenefit = !this.isVisibleReimbursementFuneralBenefit
  }

  public toggleVisibilityFuneralAllowanceBenefit() {
    this.isVisibleFuneralAllowanceBenefit = !this.isVisibleFuneralAllowanceBenefit
  }

  public isSurvivalPensionBenefitChanged(value: boolean) {
    this.item.survivalPensionBenefit = value;

    if (this.item.survivalPensionBenefit !== true) {
      this.item.survivalPensionBenefit = undefined;
    }
  }

  public isReimbursementFuneralBenefitChanged(value: boolean) {
    this.item.reimbursementFuneralBenefit = value;

    if (this.item.reimbursementFuneralBenefit !== true) {
      this.item.funeralExpense = undefined;
    }
  }

  public isFuneralAllowanceBenefitChanged(value: boolean) {
    this.item.funeralAllowanceBenefit = value;

    if (this.item.funeralAllowanceBenefit !== true) {
      this.item.livedWithDeceased = undefined;
    }
  }

  public removeTrashButton() {
    if ((this.qualificationIsBeneficiary || this.qualificationIsLegalRepresentative)
      && !this.isFuneraryOrService) {
      return true;
    } else {
      return false;
    }
  }

  public hasPortugueseNationalityChange(hasNacPT: boolean) {
/*    if (this.isFuneraryOrService) {*/
      if (hasNacPT.toString() == 'true') {
        //this.item.hasNIFPT = true;
        this.item.identificationDocumentType = "B";
      }
      else {
        //this.item.hasNIFPT = null;
        //this.item.NIF = null;
        this.item.identificationDocumentType = "P";
      }

    //}
    
  }

  public hasPortugueseNifChange(hasNIF: boolean) {
    if (!(hasNIF.toString() == 'true')) {
      this.item.NIF = null;
    }
  }

  formatDate(event: any) {
    DateHelpers.formatDateGeneral(event);
  }

  onlyNumbers(event: any) {
    DateHelpers.onlyNumbers(event);
  }

  onDateChange(event: any, dp: any) {
    let object = new Date(this.item.dateOfBirth).toISOString().split('T')[0];
    DateHelpers.onDateChange(event, dp, object);
  }

  public isDisabledByNif(): boolean {
    const notIsLegalRepresentative = this.hasLegalRepresentation?.toString() != 'true';
    let result = true;

    if (isNotNullOrUndefinedOrEmpty(this.item.NIF)) {
      result = result && this.nifValidationService.isValidNif(this.item.NIF) == false;
    } else {
      result = true;
    }
    result = result && notIsLegalRepresentative;
    return result;
  }

  public isDisabledByNifColetivo(): boolean {
    const notIsLegalRepresentative = this.hasLegalRepresentation?.toString() != 'true';
    let result = true;

    if (isNotNullOrUndefinedOrEmpty(this.item.NIF)) {
      const isValidNif = this.nifValidationService.isValidNif(this.item.NIF) == true;
      let isPessoaColectiva = true;
      if (isValidNif) {
        isPessoaColectiva = this.nifValidationService.isPessoaSingularNif(this.item.NIF) == false;
      }
      result = result && isPessoaColectiva;
    } else {
      result = true;
    }
    result = result && notIsLegalRepresentative;
    return result;
  }

  public onNifBlur() {
    const isLegalRepresentative = this.hasLegalRepresentation?.toString() == 'true';
    if (isLegalRepresentative) {
      return;
    }

    if (isNotNullOrUndefinedOrEmpty(this.item.NIF)) {
      const isValidNif = this.nifValidationService.isValidNif(this.item.NIF) == true;
      let isPessoaColectiva = false;
      if (isValidNif) {
        isPessoaColectiva = this.nifValidationService.isPessoaSingularNif(this.item.NIF) == false;
      }
      else {
        return;
      }
      if (isPessoaColectiva) {
        // É pessoa colectiva, limpa campos
        this.item.dateOfBirth = null;
        this.item.civilStateDeathDate = null;
        this.item.identificationDocumentType = null;
        this.item.identificationNumberFirst = null;
        this.item.identificationNumberLast = null;
        this.item.gender = null;
        this.item.hasNacPT = null;
        this.item.hasLegalRepresentation = null;
      }
    }
    else {
        return;
    }
  }

  public isDisabledByRL(): boolean {
    return this.hasLegalRepresentation?.toString()=='true';
  }

  public isNICDisable(): boolean {
    let result = this.isFieldDisabled('identificationNumberFirst');
    if (result) {
      result = result || this.isAIndeferir;
      result = result || this.isDisabledByNif();
      result = result || this.isDisabledByNifColetivo();
      //result = result || this.item.notEditable;
      result = result || this.isDeferida;

    }
    result = result && this.isFuneraryOrService?.toString() == 'false';
  
    return result; 
  }
}
